import { restaurantInfo } from '@/mocks/restaurantData';
import gaikan from '@/assets/gaikan.png';

export default function AccessSection() {
  return (
    <section id="access" className="relative py-24 md:py-32 overflow-hidden">
    {/* 背景画像 */}
    <img
      src={gaikan}
      alt=""
      aria-hidden="true"
      className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none select-none"
    />
    {/* 暗いオーバーレイ（文字を読みやすく） */}
    <div className="absolute inset-0 bg-black/60 pointer-events-none" />

    {/* コンテンツ（前面） */}
    <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
      <div className="flex flex-col items-center gap-12 md:gap-16 max-w-3xl mx-auto">
          <div className="w-full text-center reveal">
            <div className="inline-flex items-center gap-2 text-primary-400 font-script text-5xl">
              &mdash; Access &mdash;
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 mb-10 leading-[1.2]">
              アクセス
            </h2>

            <div className="max-w-xl mx-auto space-y-8 text-left mr-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 rounded-xl bg-accent-500/10 flex items-center justify-center mt-0.5">
                  <i className="ri-train-line text-xl text-accent-400"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-950 mb-1">最寄り駅</h4>
                  <p className="text-foreground-400 text-sm leading-relaxed">{restaurantInfo.access.station}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 rounded-xl bg-accent-500/10 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xl text-accent-400"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-950 mb-1">住所</h4>
                  <p className="text-foreground-400 text-sm leading-relaxed">{restaurantInfo.address}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 rounded-xl bg-accent-500/10 flex items-center justify-center mt-0.5">
                  <i className="ri-parking-box-line text-xl text-accent-400"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-950 mb-1">駐車場</h4>
                  <p className="text-foreground-400 text-sm leading-relaxed">{restaurantInfo.access.parking}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full reveal">
            <div className="rounded-2xl overflow-hidden h-[380px] md:h-[450px] w-full border border-foreground-100/10">
              <iframe
                src={restaurantInfo.access.mapEmbedUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Trattoria Sole アクセスマップ"
                className="w-full h-full brightness-75"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}